










































import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import {namespace} from "vuex-class";
import {IApiErrors} from '@/models/ApiModels';
import {errorHandler} from "@/services/services";
import {LOGIN_ROUTES, OTHER_ROUTES} from "@/constants/routes";
import {ANALYTIC_CLICKS} from "@/services/Analytics";
import moment from "moment";
import {IValidate} from "@/models/loginModels";
import {path} from "ramda";


const userDataModule = namespace("userData");

@Component({
  name: 'ValidateAccountView',
  components: {},
})
export default class ValidateAccountView extends Vue {
  @userDataModule.Action('validateUser')
  private validateUser !: (userData: IValidate) => Promise<any>;

  private validationError: boolean = false;
  private loading: boolean = true;


  @Watch("$route")
  private sendValidationRequest() {
    this.clearErrors();
    this.loading = true;

    setTimeout(() => {
      this.sendRequest();
    }, 2000);
  }

  private returnToLogin() {
    // we need those urls to clean because if the user saves them, they will always reset their credentials
    this.$uiBus.emit("genericMessage:show", this.$t('validationView.result'));
    this.$router.push({name: LOGIN_ROUTES.LOGIN});
  }

  private get phone(): string {
    const phone: string|undefined = path(['params', 'phone'], this.$route);
    return phone ? phone : "";
  }


  private get vCode(): string {
    const vCode: string|undefined = path(['params', 'vCode'], this.$route);
    return vCode ? vCode : "";
  }

  private created() {
    this.sendValidationRequest();
  }

  private sendRequest() {
    const validationBody: IValidate = {
      phone_number: this.phone,
      validation_code: this.vCode,
    };

    this.validateUser(validationBody)
        .then(() => this.returnToLogin())
        .catch(this.showErrors)
        .finally(() => this.loading = false);
  }

  private showErrors(err: any) {
    this.validationError = true;
    errorHandler.handleErrorsResponse(err, 'validationView.errors');
  }

  private clearErrors() {
    this.validationError = false;
  }

}
